import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable()
export class AppConfigService {
  private appConfig: any;

  async loadAppConfig(): Promise<void> {
    try {
      const response = await fetch('/assets/app-config.json');
      const data = await response.json();
      this.appConfig = data;

      environment.apiURL = data.apiURL;
      environment.hubURL = data.hubURL;
      environment.forgotPasswordUrl = data.forgotPasswordUrl;
      environment.appName = data.appName;
      environment.version = data.version;
    } catch (error) {
      console.error('Failed to load app config:', error);
      throw error;
    }
  }

  get config() {
    return this.appConfig;
  }
}
